'use client'

import {Radio as AntRadio, RadioProps} from 'antd'
import React, {useState} from 'react'
import {ControllerRenderProps} from 'react-hook-form'
import styled from 'styled-components'

import InputTooltip from '@/src/shared/ui/inputs/tooltip'
import {Label} from '@/src/shared/ui/label'

export interface IProps extends Omit<RadioProps & IInputProps & React.PropsWithChildren, 'name'> {
  id?: string
  name: string
  field: ControllerRenderProps<any>
  suppressOnChange?: boolean
}

const Radio = (props: IProps) => {
  const {name} = props
  const [id] = useState(() => `radio-${name}${'-' + props.id || ''}`)
  const {tooltip, children, onClick} = props

  return (
    <Wrapper onClick={onClick}>
      <AntRadio
        id={id}
        {...props.field}
        onChange={e => {
          if (props.suppressOnChange) {
            return
          }
          props.field.onChange(e.target.value)
          if (props.onChange) {
            props.onChange(e)
          }
        }}
        checked={props.checked || props.field.value == props.value}
        {...props}>
        <Label htmlFor={id}>{children}</Label>
        {tooltip && <InputTooltip title={tooltip} />}
      </AntRadio>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    cursor: pointer;
  }
`

export default Radio
